import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_zhengxiangshejijieduan from '../views/lanhu_zhengxiangshejijieduan/index.vue'
import lanhu_heidengshengchanjieduan from '../views/lanhu_heidengshengchanjieduan/index.vue'
import lanhu_quanguochengshuzihua from '../views/lanhu_quanguochengshuzihua/index.vue'
import lanhu_zhihuiyunwei from '../views/lanhu_zhihuiyunwei/index.vue'
import lanhu_qita from '../views/lanhu_qita/index.vue'
import lanhu_wurenshigong from '../views/lanhu_wurenshigong/index.vue'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/lanhu_quanguochengshuzihua"
  },
  {
    path: '/lanhu_zhengxiangshejijieduan',
    name: 'lanhu_zhengxiangshejijieduan',
    component: lanhu_zhengxiangshejijieduan
  },
  {
    path: '/lanhu_heidengshengchanjieduan',
    name: 'lanhu_heidengshengchanjieduan',
    component: lanhu_heidengshengchanjieduan
  },
  {
    path: '/lanhu_quanguochengshuzihua',
    name: 'lanhu_quanguochengshuzihua',
    component: lanhu_quanguochengshuzihua
  },
  {
    path: '/lanhu_zhihuiyunwei',
    name: 'lanhu_zhihuiyunwei',
    component: lanhu_zhihuiyunwei
  },
  {
    path: '/lanhu_qita',
    name: 'lanhu_qita',
    component: lanhu_qita
  },
  {
    path: '/lanhu_wurenshigong',
    name: 'lanhu_wurenshigong',
    component: lanhu_wurenshigong
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
